module.exports = __webpack_public_path__ + "static/media/blackrock-logo-b.9658763b.png";